import { Box, Card, Grid, Typography, useTheme } from '@mui/material'

const CardTabInfoTicket = ({texto,cantidad,icon,backgroundIcon}) => {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    return (
        <Card sx={{background: isDarkMode ? '#2d3a52 !important' : '#fff !important',borderRadius:5,boxShadow: 4,p:1, border: isDarkMode ? '1px solid #3d4a62' : 'none'}}>
            <Grid container mt={1} mb={1}>
                <Grid item xs={3} display='flex' justifyContent='center' alignItems='center'>
                    <Card sx={{height: 50, width:50,background: backgroundIcon ,display: 'flex', justifyContent: 'center',alignItems: 'center'}}>
                        {icon}
                    </Card>
                </Grid>
                <Grid item xs={6} display='flex' justifyContent='start' alignItems='center'>
                    <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}} variant='h4'>{texto}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Box display='flex' justifyContent='center' alignItems='center'>
                        <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h2'>{cantidad}</Typography>
                        <Typography sx={{color: isDarkMode ? '#b0bec5' : '#000',marginTop: 3,marginLeft: 1}} variant='h5'>Total</Typography>
                    </Box>
                </Grid>
            </Grid>
        </Card>
    )
}

export default CardTabInfoTicket